module.exports = __webpack_public_path__ + "static/media/Up.f580a566.svg";